export enum PlanningConfigurationSeeEvents {
  OnlyEmployee,
  EmployeeAndForeman,
  All
}
  
export enum PlanningConfigurationCreateEvents {
  OnlyEmployee,
  EmployeeAndForeman,
  All
}

export enum ActionPolicy {
  Allow = 'Allow',
  Warn = 'Warn',
  Block = 'Block'
}
  